<div class="segmented-buttons" data-test="select-language-container">
	@for (lang of languages(); track $index) {
		<button
			[attr.data-test]="lang + '-language-button'"
			[ngClass]="{ selected: lang === language() }"
			(click)="setLanguage(lang)"
		>
			{{ lang }}
		</button>
	}
</div>
